<template>
  <span>
    <!-- this "icon" version (as opposed to svg) was used before when we didn't have svg's for everything. consider removing since we don't use it anymore -->
    <q-avatar
      v-if='("icon" in icon)'
      :icon="icon.icon"
      :color="activeColor"
      text-color="white"
      :size="`${size}px` || '40px'"
      font-size="26px"
    />
    <div
      v-if='("svg" in icon)'
      class='icon-case'
      :class='{transparent: activeColor === "transparent", "purple-background": makePurple }'
      :style='{ height: `${size}px`, width: `${size}px`, borderRadius: `${size}px` }'
    >
      <img :src='icon.svg' :style='{ height: `${size*icon.sizeMultiple}px`, width: `${size*icon.sizeMultiple}px` }' />
    </div>
  </span>
</template>

<script>
import AnalysisIcon from '@/assets/analysis.svg'
import SearchIcon from '@/assets/search.svg'
import ApiIcon from '@/assets/api.svg'
import CloseSidebarSvg from '@/assets/sidebar_hide_icon.svg'
import OpenSidebarSvg from '@/assets/sidebar_open.svg'
import SeeMoreTools from '@/assets/SeeMoreTools.svg'
import LinksIcon from '@/assets/links.svg'
import ActivityIcon from '@/assets/activity.svg'

export default {
  props: {
    tool: String,
    makePurple: Boolean,
    size: Number,
    noBackground: Boolean,
  },
  computed: {
    isCurrent () {
      return this.tool === this.$route.name
    },
    activeColor () {
      if (this.noBackground) return 'transparent'
      return (this.isCurrent | this.makePurple) ? 'our-purple' : 'our-faded-gray'
    },
    icon () {
      return {
        trending: { svg: AnalysisIcon, sizeMultiple: 2.5 }, // 'trending_up',
        timeline: { svg: AnalysisIcon, sizeMultiple: 2.5 }, // 'trending_up',
        links: { svg: LinksIcon, sizeMultiple: 2.5 },
        activity: { svg: ActivityIcon, sizeMultiple: 2.5 },
        search: { svg: SearchIcon, sizeMultiple: 2.5 },
        api: { svg: ApiIcon, sizeMultiple: 1.5 },
        closeSidebar: { svg: CloseSidebarSvg, sizeMultiple: 0.5 },
        openSidebar: { svg: OpenSidebarSvg, sizeMultiple: 0.5 },
        seeMoreTools: { svg: SeeMoreTools, sizeMultiple: 0.5 },
      }[this.tool]
    }
  }
}
</script>

<style scoped lang="scss">
.icon-case {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-white);
}

.purple-background {
  background-color: var(--color-white);
}
</style>
